import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import pickBy from 'lodash/pickBy';

class CharacterVoiceSearchService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      voices: [],
      isVoiceSearchModalOpen: false,
    });
  }

  handleOpen = action((accent) => {
    this.voices = [];

    this.form.reset();
    this.form.setInitialValues({});
    this.form.setValue('accent', accent);
    this.form.setValue('type', 'library');

    this.isVoiceSearchModalOpen = true;
    this.handleLoad();
  });

  handleClose = action(() => {
    this.isVoiceSearchModalOpen = false;
  });

  handleLoad = action(() => {
    const { accent, ...query } = this.form.getValues();

    this.fetch
      .fetch({
        url: `/characters/${accent}/voices`,
        method: 'GET',
        apiVersion: 'v3',
        query: pickBy(query, (x) => !!x),
      })
      .then(() => {
        this.voices = this.fetch.data || [];
      })
      .catch(() => {
        this.voices = this.fetch.data = [];
      });
  });
}

const characterVoiceSearchService = new CharacterVoiceSearchService();

export default characterVoiceSearchService;
